import { Component } from 'react'
import { extendObservable, transaction } from 'mobx'
import { observer } from 'mobx-react'
import { browserHistory } from 'react-router'
import { CSSTransitionGroup } from 'react-transition-group'

import * as h from 'h'

import { twitterUrl } from 'config'

import { twitterEntities } from 'utils'

import Panel from './Panel'

import styles from './styles-panel.scss'

export default class StoriesPanel extends Component {
  render () {
    const backgroundImage = 'url(/landingimage/stories)'
    return h.h(Panel, { onArrowClick: null, noHeightRestriction: true, backgroundImage },
      h.div(h.ca(styles.standardContent),
        h.h(Tickers)))
  }
}

// Get stories from html
const givenStories = {
  news: (window && Array.isArray(window.newsTickerStoriesInit) && window.newsTickerStoriesInit) || [],
  twitter: ((window && Array.isArray(window.twitterTickerStoriesInit) && window.twitterTickerStoriesInit) || []).map(tweet =>
    ({ ...tweet, content: twitterEntities(tweet.title, tweet.entities) }))
}

@observer
class Tickers extends Component {
  static defaultProps = {
    pushInAmount: 1,
    take: 4,
    freq: 8000
  }

  // --------------------------------------------------------------------------
  // Lifecycle
  // --------------------------------------------------------------------------

  componentWillMount () {
    extendObservable(this, {
      head: 0,
      timeout: null // reference to setTimeout return value
    })
  }

  componentDidMount () {
    this.tick()
  }

  componentWillUnmount () {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  // --------------------------------------------------------------------------
  // Actions
  // --------------------------------------------------------------------------

  tick = () => {
    const { pushInAmount, freq } = this.props

    transaction(() => {
      this.head = this.head + pushInAmount
      this.timeout = window.setTimeout(this.tick, freq)
    })
  }

  // Handles both heading (if story=undefined) and story clicks
  onClick (type, story = null) {
    if (type === 'twitter') {
      window.open && window.open(story ? story.url : twitterUrl, '_blank')
    } else {
      browserHistory.push('/' + type)
      // Wait until after the landing slide has pulled up before bringing in the
      // story popout.
      if (story) {
        setTimeout(() => {
          const title = encodeURIComponent(story.title)
          browserHistory.push(`/${type}/${story.id}/${title}`)
        }, 1200)
      }
    }
  }

  // --------------------------------------------------------------------------
  // Helpers
  // --------------------------------------------------------------------------

  makeStory (type, story) {
    const onClick = () =>
      this.onClick(type, story)

    return h.span({ key: story.id, ...h.ca(styles.story, styles[`story-${type}`]) },
      story.avatar && (
        h.z({ onClick: onClick },
          h.img({ src: story.avatar, name: '' }))
      ),
      (story.content ? h.span : h.z)({ onClick: story.content ? null : onClick, ...h.ca(styles.storyLink, { [styles.storyLinkTweet]: story.content }) },
        story.content ? h.raw({ element: 'span', content: story.content }) : story.title))
  }

  // stories, adjusted for current this.head
  get stories () {
    const { take } = this.props

    return Object.keys(givenStories).reduce((acc, k) => {
      const sot = givenStories[k]

      const at = this.head % sot.length
      const nu = at === 0
        ? sot.slice(0, take)
        : sot.slice(at).concat(sot.slice(0, at - 1)).slice(0, take)

      acc[k] = nu
      return acc
    }, {})
  }

  makeTicker (type) {
    const stories = this.stories

    const moreOnClick = () => this.onClick(type, null)

    const more = h.z({ onClick: moreOnClick, ...h.ca(styles.storiesMoreButton) },
        'View All',
        h.icon({ name: 'arrow-circle-right' }))

    const id = type === 'twitter' ? 'twitter-anchor' : null

    return h.div({ key: type, ...h.ca(styles.stories) },
      h.z({
        id,
        onClick: moreOnClick,
        ...h.ca(styles.storiesHeading)
      }, type),
      h.h(CSSTransitionGroup, {
        transitionName: 'tickerStory',
        transitionEnterTimeout: 1000,
        transitionLeaveTimeout: 1000
      },
        stories[type].map(s => this.makeStory(type, s))),
      more)
  }

  // --------------------------------------------------------------------------
  // Render
  // --------------------------------------------------------------------------

  render () {
    return h.div(null, Object.keys(givenStories).map(::this.makeTicker))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Landing/StoriesPanel.js